import { useUiTranslator } from "../../../../hooks/useUiTranslator";
import { customPalette } from "../../../../theme/theme";

import { JSX } from "react";

import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

export function FooterTextLabel(): JSX.Element {
  const t = useUiTranslator();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        ml: 4,
        whiteSpace: "nowrap",
      }}
    >
      <Typography color={customPalette.primary.contrastText}>
        {t("CustomApp:footerCopyright", "© {{year}} WEG | Gear ProSelect", {
          year: new Date().getFullYear(),
        })}
      </Typography>
    </Box>
  );
}
